import {
  API_BASE_BANK_ROUTING,
  API_BASE_POSTAL_CODE,
  API_BASE_VALIDATE_ADDRESS,
  API_HOME_CREDIT_BOX,
  API_HOME_NEWSLETTER,
  API_HOME_SUBMIT_CONTACTUS,
} from 'config'
import Api from 'services/api'

export const requestNewsletter = (email: string) => {
  return Api.post(API_HOME_NEWSLETTER, { email })
}

export const submitContactUs = (data: Record<string, string>) => {
  return Api.post(API_HOME_SUBMIT_CONTACTUS, data)
}

export const getHomeCreditBox = () => {
  return Api.get(API_HOME_CREDIT_BOX)
}

export const validateAddress = (value: string) => {
  return Api.post(API_BASE_VALIDATE_ADDRESS, { value })
}

export interface IBankRoutingLookup {
  routingNumber: string
  /** Whether the routing number itself is well formed - separate from whether a name was found. */
  valid: boolean
  /** Empty when the routing number is fine but the directory had no entry for it. */
  bankName: string
  city?: string
  state?: string
  source?: string
  error?: string
}

/** Resolve a routing number to its bank so the bank-name field can fill itself in. */
export const lookupBankRouting = (routingNumber: string): Promise<IBankRoutingLookup> => {
  return Api.get(API_BASE_BANK_ROUTING, {}, { routingNumber })
}

export interface IPostalCodeLookup {
  postalCode: string
  city: string
  state: string
  county: string
}

/**
 * ZIP code -> city, state and county, so a form can fill those in from the ZIP alone. Every field
 * comes back empty for a ZIP that resolves to nothing, which means "leave what was typed alone".
 */
export const lookupPostalCode = (postalCode: string): Promise<IPostalCodeLookup> => {
  return Api.get(API_BASE_POSTAL_CODE, {}, { postalCode })
}
